// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectComponent_wrapper__BMkVK","categoryName":"SelectComponent_categoryName__KYE6h"};